/**
 * 忘记密码页面
 */
// 必须引，否则没有css变量
import '@bfe/moly/dist/es/theme/cssVars/index.css';
// 必须引 否则组件没有样式
import '@bfe/moly/dist/es/theme/styles/tailwind.css';
// if you only need IBM fonts
import '@bfe/moly/dist/es/theme/font/font.css';
// import './index.less';
import '@/utils/skynet';

import { ToastContainer } from '@bfe/moly';
import { message } from 'antd';
import React, { FC, lazy, Suspense, useEffect } from 'react';

import { useFingerPrint } from '@/hooks/useFingerPrint';
import useSecurityPreload from '@/hooks/useSecurityPreload';
import { I18nProvider, useI18nContext } from '@/i18n/I18n';
import { UserProvider, useUserStore } from '@/store/useUser';
import { demoAccountAllowPath } from '@/utils/constants/common';
import { WHITE_HOST } from '@/utils/constants/common';
import { reactRTLJsInit, rtlAdapter } from '@/utils/rtl';
import { SubAccountLoginRedirectErrorTrack } from '@/utils/trace-list/subAccount';
import { isMobile } from '@/utils/ua';

import useHtmlTranslate from './hooks/useHtmlTranslate';
import { SubAccountLoginProvider } from './store/captchaProvider';

const UniframeHeaderFooter = lazy(
  () => import('@/components/UniframeHeaderFooter'),
);

const AppAdapter = lazy(() => import('@/components/AppAdapter'));
const OAuthHeader = lazy(() => import('@/components/OAuthHeader'));

// const LazyEntry = lazy(() => import('./lazyEntry'));
import { createRoot } from 'react-dom/client';

import { isOAuthHeader } from '@/utils/oatu';

import LazyEntry from './lazyEntry';

reactRTLJsInit(React);

const SubAccountLoginApp: FC = () => {
  const [$t, lang] = useI18nContext();

  useHtmlTranslate();
  const { fingerReport } = useFingerPrint();
  const {
    loading: userInfoLoading,
    accountIdentity,
    userProfile,
  } = useUserStore();

  useEffect(() => {
    rtlAdapter();

    if (isMobile()) {
      const el = document.createElement('meta');
      el.setAttribute('name', 'viewport');
      el.setAttribute(
        'content',
        'width=device-width,initial-scale=0.85,user-scalable=no',
      );
      document.head.append(el);
    }
  }, []);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const path = window.location.pathname;
      if (
        !userInfoLoading &&
        accountIdentity.includes('demo_account') &&
        !demoAccountAllowPath.includes(path)
      ) {
        message.info({
          content: 'Demo accounts cannot access this page',
          onClose() {
            window.location.href = window.location.origin;
          },
        });
      }
    }
  }, [accountIdentity, userInfoLoading]);

  useSecurityPreload();

  useEffect(() => {
    fingerReport('wf04', '2');
  }, []);

  const toLogin = () => {
    const search = new URLSearchParams(window.location.search);

    const fromOAuth = search.get('from') === 'oauth';

    let url = `/login?${search}`;
    const mainLoginUrl = search.get('main_login_url');
    if (fromOAuth) {
      url = `/${lang}/oauth-login?${search}`;
    } else if (mainLoginUrl) {
      try {
        const mainLoginUrlNew = new URL(mainLoginUrl);
        if (
          WHITE_HOST.some((host) => mainLoginUrlNew?.host?.indexOf?.(host) > -1)
        ) {
          url = mainLoginUrl;
        } else {
          SubAccountLoginRedirectErrorTrack(search);
        }
      } catch (error) {
        /* empty */
      }
    }
    window.location.replace(url);
  };

  useEffect(() => {
    if (isOAuthHeader()) {
      const container = document.getElementById('__bybit_oauth_header__')!;
      createRoot(container).render(
        <Suspense>
          <OAuthHeader />
        </Suspense>,
      );
    }
  }, []);

  useEffect(() => {
    const subAccountMainAccountBtn = document.querySelector(
      '#subAccountMainAccountBtn',
    );
    if (subAccountMainAccountBtn) {
      subAccountMainAccountBtn.addEventListener('click', toLogin);
    }
  }, []);

  return (
    <>
      <Suspense>
        <UniframeHeaderFooter userInfo={userProfile} />
        <AppAdapter />
        {/* {isOAuthHeader() && <OAuthHeader />} */}
      </Suspense>
      <LazyEntry />
      <ToastContainer />
    </>
  );
};

const SubAccountLoginWrap = () => {
  return (
    <I18nProvider>
      <UserProvider>
        <SubAccountLoginProvider>
          <SubAccountLoginApp />
        </SubAccountLoginProvider>
      </UserProvider>
    </I18nProvider>
  );
};

export default SubAccountLoginWrap;
